import { register } from "../auth_store.js";
import { authLayout, field, btnPrimary, alertBox, bindForm } from "./auth_shell.js";
import { navigate } from "../router.js";
import { t } from "../i18n.js";

export function renderRegister(root) {
  root.innerHTML = authLayout({
    title: t("Create account"),
    subtitle: t("Start staging apartments and sharing walkable 3D tours."),
    childrenHtml: `
      <div id="reg-alert"></div>
      <form class="portal-form" novalidate>
        ${field({ id: "name", label: t("Full name"), type: "text", placeholder: "Alex Morgan", autocomplete: "name" })}
        ${field({ id: "email", label: t("Work email"), type: "email", placeholder: "you@studio.com", autocomplete: "email" })}
        ${field({ id: "password", label: t("Password"), type: "password", placeholder: t("At least 8 characters"), autocomplete: "new-password" })}
        ${field({ id: "confirm", label: t("Confirm password"), type: "password", placeholder: t("Repeat password"), autocomplete: "new-password" })}
        <label class="portal-check portal-check--block">
          <input type="checkbox" name="terms" required />
          <span>${t("I agree to the Terms of Service and Privacy Policy")}</span>
        </label>
        ${btnPrimary(t("Create account"), { type: "submit" })}
      </form>
    `,
    footerHtml: `
      <span class="portal-muted">${t("Already have an account?")}</span>
      <a class="portal-link portal-link--strong" href="#/login">${t("Sign in")}</a>
    `,
  });

  bindForm(root, (values) => {
    const alertEl = root.querySelector("#reg-alert");
    if (values.password !== values.confirm) {
      alertEl.innerHTML = alertBox(t("Passwords do not match."));
      return;
    }
    if (values.terms !== "on") {
      alertEl.innerHTML = alertBox(t("Please accept the terms to continue."));
      return;
    }
    const res = register({ name: values.name, email: values.email, password: values.password });
    if (!res.ok) {
      alertEl.innerHTML = alertBox(t(res.error));
      return;
    }
    navigate("/dashboard", true);
  });
}
